var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTire02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#002455;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-130)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 35,
    height: 35,
    transform: "translate(130)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M13.5-.75A14.25,14.25,0,0,1,23.576,23.576,14.25,14.25,0,1,1,3.424,3.424,14.157,14.157,0,0,1,13.5-.75Zm0,27A12.75,12.75,0,0,0,22.516,4.484,12.75,12.75,0,1,0,4.484,22.516,12.667,12.667,0,0,0,13.5,26.25Z",
    transform: "translate(134 4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M147.5,27.579A10.079,10.079,0,1,1,157.579,17.5,10.09,10.09,0,0,1,147.5,27.579Zm0-18.658a8.579,8.579,0,1,0,8.579,8.579A8.589,8.589,0,0,0,147.5,8.921Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTire02);
export default __webpack_public_path__ + "static/media/icon_tire_02.7cef489e6fea132b2f51e3207779c64b.svg";
export { ForwardRef as ReactComponent };